'use client';

import React__default from 'react';
import { colors } from '../../Colors/index.js';

var TwitterIcon = function (_a) {
    var _b = _a.width, width = _b === void 0 ? 24 : _b, _c = _a.height, height = _c === void 0 ? 24 : _c, _d = _a.fill, fill = _d === void 0 ? colors.grey[50] : _d;
    return (React__default.createElement("svg", { xmlns: 'http://www.w3.org/2000/svg', width: width, height: height, viewBox: '0 0 24 24', fill: 'none' },
        React__default.createElement("path", { d: 'M21.0955 20.8L14.0595 10.5424L14.0715 10.552L20.4155 3.19995H18.2955L13.1275 9.18395L9.02352 3.19995H3.46352L10.0323 12.7768L10.0315 12.776L3.10352 20.8H5.22352L10.9691 14.1424L15.5355 20.8H21.0955ZM8.18352 4.79995L18.0555 19.2H16.3755L6.49552 4.79995H8.18352Z', fill: fill })));
};
var TwitterIcon$1 = React__default.memo(TwitterIcon);

export { TwitterIcon$1 as default };
//# sourceMappingURL=Twitter.js.map
